import { useState } from "react";
import { useSignup } from "../hooks/useSignup";

const Signup = () => {
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [businessName, setBusinessName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const {signup, error, isLoading} = useSignup();

    const handleSubmit = async (e) => {
        e.preventDefault()

        //signup function comes from useSignup hook that was created
        await signup(email, firstName, lastName, businessName, phoneNumber, password, confirmPassword);

    }

    return (
        <form className="signup" onSubmit={handleSubmit}>
            <div className="signup-header">
                <h3>Start Free For 7 Days!</h3>
                <h3>Sign Up</h3>
            </div>
            <div className="inner-auth-form-container">
                <label>Email</label>
                <input 
                    type="text"
                    required
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                />
            </div>
            <div className="inner-auth-form-container">
                <label>First Name</label>
                <input 
                    type="text"
                    required
                    onChange={(e) => setFirstName(e.target.value)}
                    value={firstName}
                />
            </div>
            <div className="inner-auth-form-container">
                <label>Last Name</label>
                <input 
                    type="text"
                    required
                    onChange={(e) => setLastName(e.target.value)}
                    value={lastName}
                />
            </div>
            <div className="inner-auth-form-container">
                <label>Business Name</label>
                <input 
                    type="text"
                    onChange={(e) => setBusinessName(e.target.value)}
                    value={businessName}
                />
            </div>
            <div className="inner-auth-form-container">
                <label>Phone Number</label>
                <input 
                    type="tel"
                    required
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    value={phoneNumber}
                />
            </div>
            <div className="inner-auth-form-container">
                <label>Password</label>
                <input 
                    type="password"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                />
            </div>
            <div className="inner-auth-form-container">
                <label>Confirm Password</label>
                <input 
                    type="password"
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    value={confirmPassword}
                />
            </div>
            <p>Password must contain Uppercase, Lowercase, Number, and Special Character</p>
            <button className="btn btn-light" disabled={isLoading}>Sign Up</button>
            {error && <div className="error">{error}</div> }
        </form>
    )
}

export default Signup;